var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice",on:{"click":_vm.toggle}},[_c('div',{class:['process', { 'play': _vm.isPlay }],style:({width: _vm.process + '%'})}),_vm._v(" "),_c('div',{staticClass:"icon",style:({backgroundPosition: _vm.position + 'px 0'})}),_vm._v(" "),_c('audio',{ref:"audio",attrs:{"src":_vm.src}}),_vm._v(" "),_c('div',{staticClass:"timer"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b437912","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/voice/Voice.vue
// module id = null
// module chunks = 